module.exports = __webpack_public_path__ + "img/BonnieofBlood.5e94a46a.png";